module.exports = __webpack_public_path__ + "static/media/Nursery_3.f524d7dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/nursery/Nursery_3.png
// module id = 1282
// module chunks = 3